import { Info, Spinner } from '@mi-front/ui';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { Alert } from '@mui/material';
import { useStation } from '../../../../../../../../core/stations/hooks/useStation';
import { useIsExternalExportEnabled } from '../../../../../../hooks/isExternalExportEnabled';
import { useFragmentCtx } from '../../../../context/fragment-ctx';
import { ExternalExportStatusInfo } from './ExternalExportStatusInfo';
import { useFragmentExternalExport } from './useFragmentExternalExport';

import { FormattedMessage } from 'react-intl';
export const ExternalExportStatusV1 = () => {
  const fragment = useFragmentCtx();

  const externalExportEnabled = useIsExternalExportEnabled(useStation(fragment.stationId));

  const query = useFragmentExternalExport(fragment);

  return (
    <Info
      title={
        <>
          <FileUploadIcon />{' '}
          <FormattedMessage id="fragments.exportStatus.title" defaultMessage="External export" />
        </>
      }
      data={
        !externalExportEnabled ? (
          <div>
            <Alert severity="warning">
              <FormattedMessage
                id="fragments.exportStatus.externalExportNotEnabled"
                defaultMessage="El export externo no está habilitado, contacte a soporte."
              />
            </Alert>
          </div>
        ) : query.isLoading ? (
          <Spinner />
        ) : (
          query.data && <ExternalExportStatusInfo fragment={query.data} />
        )
      }
    />
  );
};
